import Swiper from 'swiper';

new Swiper('.swiper__offers', {
    grabCursor: true,
    slidesPerView: 'auto',
    spaceBetween: 20,
    speed: 400,
});
const allowanceTypeElement = document.querySelector('#allowanceType');
const offersCarouselElement = document.querySelector('.motab-offers__carousel');

const updateOffersCarousel = function() {
    let type = allowanceTypeElement.value || 'civilian';
    if (brand == 'fiat') {
        type = 'civilian';
    }

    const cards = offersCarouselElement.querySelectorAll('[data-type]');
    const cardsLength = cards.length;
    if (cardsLength == 0) {
        return;
    }
    for (let index = 0; index < cardsLength; index++) {
        const card = cards[index];
        if (card.dataset.type == type) {
            card.classList.add('motab-offers__amount--active');
        } else {
            card.classList.remove('motab-offers__amount--active');
        }
    }
}

if (allowanceTypeElement) {
    updateOffersCarousel();

    allowanceTypeElement.addEventListener('change', updateOffersCarousel);

    // $('#allowanceType').on('change', function() {
    //     let type = $(this).val() || 'civillian';
    //     if (brand == 'fiat') {
    //         type = 'civillian';
    //     }

    //     $('#offersCarousel').find('[data-type]').removeClass('motab-offers__amount--active');
    //     $('#offersCarousel').find(`[data-type="${type}"]`).addClass('motab-offers__amount--active');
    // });
}